import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_eRryzCAUP6HR: {
	id: 'prd_eRryz2DEV2CAUP6HR'
	ident: 'prd_eRryzCAUP6HR'
	sku: 'simple_premium_4w_6_79_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_Ym7M72DEV2DMYZCZA'
			amount: 44
			amount_usd: 6.79
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.79
			discount: 37.21
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_NFJoc2DEV2Y2JCxtW'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_eRryzCAUP6HR, SubscriptionProduct>
const prd_eRryzCAUP6HR = { ident: 'prd_eRryzCAUP6HR' } as typeof _prd_eRryzCAUP6HR

export default prd_eRryzCAUP6HR
